import React from "react";
import themeLarge from "../ThemeLarge";
import DOMPurify from "dompurify";
import KeywordView from "../project/Keywords";

class BlogContentView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      urlTitles: {}, // store { url: title }
    };
  }

  componentDidMount() {
    const allUrls = this.extractUrls(this.props.content);
    if (allUrls.length > 0) {
      this.fetchTitles(allUrls);
    }
  }

  extractUrls(content) {
    const urlRegex = /\bhttps?:\/\/[^\s<)]+/g;
    const matches = content.match(urlRegex);
    return matches ? Array.from(new Set(matches)) : [];
  }

  async fetchTitles(urls) {
    return;
    const apiUrl = process.env.REACT_APP_TITLE_API_URL;
    if (!apiUrl) {
      console.error("API URL not defined in .env");
      return;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ urls }),
      });

      const data = await response.json();
      if (Array.isArray(data)) {
        const urlTitleMap = {};
        data.forEach((item) => {
          console.log(item);
          if (item.url && item.title) {
            urlTitleMap[item.url] = item.title;
          }
        });
        this.setState({ urlTitles: urlTitleMap });
      } else {
        console.error("Unexpected response format:", data);
      }
    } catch (err) {
      console.error("Error fetching titles:", err);
    }
  }

  processBlogContent(content, photos) {
    if (!content) return "";

    // Trim the content first
    let processedContent = content.trim();

    // REMOVE all <br>, <br/>, <br /> tags (case-insensitive)
    processedContent = processedContent.replace(/<br\s*\/?>/gi, "");

    // Replace [image 0], [image 1], etc.
    if (photos && photos.length > 0) {
      photos.forEach((photoUrl, index) => {
        const placeholder = `[image ${index}]`;
        const imageTag = `
                <div style="width: 100%; display: flex; justify-content: center;">
                  <img 
                    src="${photoUrl}" 
                    alt="Blog Image ${index}" 
                    loading="lazy"
                    style="
                      width: 100%;
                      max-width: 700px;
                      height: auto;
                      border-radius: 6px;
                      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
                    "
                  />
                </div>
              `;
        processedContent = processedContent.replaceAll(placeholder, imageTag);
      });
    }

    // Handle TLDR
    processedContent = this.replaceTldrMarkers(processedContent);
    // Convert any plain URL into clickable links before sanitizing
    processedContent = this.convertLinks(processedContent);

    return processedContent;
  }

  convertLinks(content) {
    const urlRegex = /\bhttps?:\/\/[^\s<)"]+/g;
    const { urlTitles } = this.state;

    // Step 1: Temporarily escape existing anchor tags
    const anchorPlaceholderMap = {};
    let anchorIndex = 0;

    const contentWithoutAnchors = content.replace(
      /<a [^>]*>.*?<\/a>/gi,
      (match) => {
        const key = `__ANCHOR_${anchorIndex++}__`;
        anchorPlaceholderMap[key] = match;
        return key; // Replace with placeholder
      }
    );

    // Step 2: Replace plain-text URLs only
    const convertedContent = contentWithoutAnchors.replace(
      urlRegex,
      (match) => {
        // Firebase Storage links are left as-is
        if (match.startsWith("https://firebasestorage.googleapis.com")) {
          return match;
        }

        const titleText = urlTitles[match] || this.extractHostname(match);
        return `<a href="${match}" target="_blank" rel="noopener noreferrer" style="color: ${themeLarge.colors.text}; font-weight: 600">${titleText}</a>`;
      }
    );

    // Step 3: Restore the original <a> tags
    const finalContent = convertedContent.replace(
      /__ANCHOR_\d+__/g,
      (placeholder) => {
        return anchorPlaceholderMap[placeholder] || placeholder;
      }
    );

    return finalContent;
  }

  extractHostname(url) {
    try {
      const urlObj = new URL(url);
      let hostname = urlObj.hostname;
      if (hostname.startsWith("www.")) {
        hostname = hostname.slice(4);
      }
      return `(${hostname})`; // fallback if no title
    } catch {
      return url;
    }
  }

  replaceTldrMarkers(content) {
    const tldrRegex = /&lt;&lt;TLDR&gt;&gt;(.*?)&lt;&lt;END&gt;&gt;/gs;
    return content.replace(tldrRegex, (_, match) => {
      return `<div class="tldr">${match.trim()}</div>`;
    });
  }

  render() {
    const { content, photos, tags } = this.props;

    return (
      <div className="container">
        <style>
          {`
          blockquote {
            font-style: italic;
            border-left: 4px solid ${themeLarge.colors.primary};
            margin: 1.5em 0;
            padding: 1em;
            background-color: ${themeLarge.colors.secondary};
          } 
            h1 {
            color: ${themeLarge.colors.primary};
            font-weight: 800;
            }

            h2 {
            color: ${themeLarge.colors.primary};
            padding: 0.5em 0;
            font-weight: 600;
            font-size: 2.5em;
            }

            pre {
            background-color: #131200;
            color: ${themeLarge.colors.secondary};
            padding: 1em;
            }

            p, h3, li, ol, ul, h4,h5, h6 {
            color: ${themeLarge.colors.text};}

            a {
            color: ${themeLarge.colors.primary};
            font-size: 1.1em;
            }

            .tldr {
              background: ${themeLarge.colors.bg};
              padding: 10px;
              border-left: 4px solid ${themeLarge.colors.gradient};
              font-weight: 600;
            }
        `}
        </style>
        <div className="row">
          <div className="col-md-2"></div>
          <div
            className="col-md-8 mt-3 mb-4"
            style={{
              fontFamily: "Kumbh Sans",
            }}
          >
            <div
              style={{
                marginBottom: "50px",
                fontSize: themeLarge.fontSize.body,
              }}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(
                  this.processBlogContent(content, photos)
                ),
              }}
            />

            {/* add tags here */}
            {tags && tags.length > 0 && (
              <div className="row">
                <p style={{ fontSize: themeLarge.fontSize.small }}> Tags </p>
                {tags.map((word, index) => (
                  <KeywordView key={index} keyword={word} />
                ))}
              </div>
            )}
          </div>
          <div className="col-md-2"></div>
        </div>
      </div>
    );
  }
}

export default BlogContentView;
